module.exports = __webpack_public_path__ + "img/images_homebanner_3_1.e04fc16e.png";